export const getCurrentFeature = (state) => state.map.currentFeature;
export const getBaseMapName = (state) => state.map.baseMapName;
export const getOverlayFeature = (state) => state.map.overlayFeature;
export const getMeasurerActive = (state) => state.map.measurerActive;
